import { render, staticRenderFns } from "./ProductSectionNotes.vue?vue&type=template&id=479a57e3&scoped=true"
import script from "./ProductSectionNotes.vue?vue&type=script&lang=js"
export * from "./ProductSectionNotes.vue?vue&type=script&lang=js"
import style0 from "./ProductSectionNotes.vue?vue&type=style&index=0&id=479a57e3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479a57e3",
  null
  
)

export default component.exports